module.exports = __webpack_public_path__ + "static/media/down_arrow.0491a835.png";